import { SearchPage } from 'Components'
import TemplateSearchPage from 'Stores/shopify-spark-generic/Templates/SearchPage.rt'
import { FacetTiles } from 'Components'
import TemplatefacetTilessubtitles from 'Stores/_default-store/Templates/facetTiles/subtitles.rt'
import { SearchHeader } from 'Components'
import { SearchResult } from 'Components'
import { SearchBox } from 'Components'
import TemplateSearchBox from 'Stores/_default-store/Templates/SearchBox.rt'
import { VehicleWidget } from 'Components'
import TemplatefitmentSearchcollapsibleVehicleWidget from 'Stores/mudify4x4-staging/Templates/fitmentSearch/collapsibleVehicleWidget.rt'
import { RequestPanel } from 'Components'
import TemplateHomeWheelTireBar from 'Stores/shopify-spark-generic/Templates/HomeWheelTireBar.rt'
import { Garage } from 'Components'
import TemplatefitmentSearchgarage from 'Stores/_default-store/Templates/fitmentSearch/garage.rt'
import { SingleVehicleGarage } from 'Components'
import TemplatefitmentSearchsingleVehicleGarage from 'Stores/mudify4x4-staging/Templates/fitmentSearch/singleVehicleGarage.rt'
import { FitmentTable } from 'Components'
import TemplatefitmentSearchfitmentTable from 'Stores/_default-store/Templates/fitmentSearch/fitmentTable.rt'
import TemplatefacetTileshierarchicalContainer from 'Stores/_default-store/Templates/facetTiles/hierarchicalContainer.rt'
import TemplatefacetTilesalphabeticalContainer from 'Stores/_default-store/Templates/facetTiles/alphabeticalContainer.rt'
import { RelatedItems } from 'Components'
import TemplateproductrelatedItems from 'Stores/_default-store/Templates/product/relatedItems.rt'
import { BuyItemsTogether } from 'Components'
import TemplateproductboughtTogether from 'Stores/_default-store/Templates/product/boughtTogether.rt'
import { SearchBoxDialog } from 'Components'
import TemplateSearchBoxDialog from 'Stores/_default-store/Templates/SearchBoxDialog.rt'
import { SearchBoxDialogButton } from 'Components'
import TemplatesearchBoxdialogButtonAdaptable from 'Stores/_default-store/Templates/searchBox/dialogButtonAdaptable.rt'
import TemplatefitmentSearchheaderVehicleWidget from 'Stores/mudify4x4-staging/Templates/fitmentSearch/headerVehicleWidget.rt'
import { VerifyFitment } from 'Components'
import TemplatefitmentSearchverifyFitment from 'Stores/mudify4x4-staging/Templates/fitmentSearch/verifyFitment.rt'
import { FacetBar } from 'Components'
import { FacetDialog } from 'Components'
import TemplateCustomFacetDialog from 'Stores/mudify4x4-staging/Templates/CustomFacetDialog.rt'
import { FacetPanel } from 'Components'
import TemplateHeaderFacetPanelContainer from 'Stores/mudify4x4-staging/Templates/HeaderFacetPanelContainer.rt'
import { VehicleWidgetDialog } from 'Components'
import TemplatefitmentSearchdialog from 'Stores/_default-store/Templates/fitmentSearch/dialog.rt'
import TemplatefitmentSearchpackagesVehicleWidget from 'Stores/mudify4x4-staging/Templates/fitmentSearch/packagesVehicleWidget.rt'
import TemplateHomeVehicleWidgetPanel from 'Stores/mudify4x4-staging/Templates/HomeVehicleWidgetPanel.rt'

export const compMap = {
  SearchPage,
FacetTiles,
SearchHeader,
SearchResult,
SearchBox,
VehicleWidget,
RequestPanel,
Garage,
SingleVehicleGarage,
FitmentTable,
RelatedItems,
BuyItemsTogether,
SearchBoxDialog,
SearchBoxDialogButton,
VerifyFitment,
FacetBar,
FacetDialog,
FacetPanel,
VehicleWidgetDialog
} 
export const tplMap = {
  'SearchPage': TemplateSearchPage,
'facetTiles/subtitles': TemplatefacetTilessubtitles,
'SearchBox': TemplateSearchBox,
'fitmentSearch/collapsibleVehicleWidget': TemplatefitmentSearchcollapsibleVehicleWidget,
'HomeWheelTireBar': TemplateHomeWheelTireBar,
'fitmentSearch/garage': TemplatefitmentSearchgarage,
'fitmentSearch/singleVehicleGarage': TemplatefitmentSearchsingleVehicleGarage,
'fitmentSearch/fitmentTable': TemplatefitmentSearchfitmentTable,
'facetTiles/hierarchicalContainer': TemplatefacetTileshierarchicalContainer,
'facetTiles/alphabeticalContainer': TemplatefacetTilesalphabeticalContainer,
'product/relatedItems': TemplateproductrelatedItems,
'product/boughtTogether': TemplateproductboughtTogether,
'SearchBoxDialog': TemplateSearchBoxDialog,
'searchBox/dialogButtonAdaptable': TemplatesearchBoxdialogButtonAdaptable,
'fitmentSearch/headerVehicleWidget': TemplatefitmentSearchheaderVehicleWidget,
'fitmentSearch/verifyFitment': TemplatefitmentSearchverifyFitment,
'CustomFacetDialog': TemplateCustomFacetDialog,
'HeaderFacetPanelContainer': TemplateHeaderFacetPanelContainer,
'fitmentSearch/dialog': TemplatefitmentSearchdialog,
'fitmentSearch/packagesVehicleWidget': TemplatefitmentSearchpackagesVehicleWidget,
'HomeVehicleWidgetPanel': TemplateHomeVehicleWidgetPanel
};